import React, { useEffect } from 'react';
import { SnackbarProvider, useSnackbar } from 'notistack';
import { useRecoilState } from 'recoil';
import { alertState } from '../../recoil-store/recoil-state';

function SnackBarEnqueue() {
    const [alert, setAlert] = useRecoilState(alertState);
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        if (alert.show) {
            enqueueSnackbar(
                <span>
                    {alert.message}
                    {alert.link && (
                        <a
                            href={alert.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#00f', textDecoration: 'underline' }}
                        >
                            {" " + alert.link}
                        </a>
                    )}
                </span>,
                {
                    variant: alert.severity,
                }
            );
        }
    }, [alert, enqueueSnackbar]);

    const handleTimeOut = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setAlert((a) => ({ ...a, show: false, message: '', severity: 'info' }));
    };

    return null;
}

function SnackBarNotification() {
    return (
        <div data-test="component-snackbar">
            <SnackbarProvider
                maxSnack={3}
                autoHideDuration={3000}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <SnackBarEnqueue />
            </SnackbarProvider>
        </div>
    );
}

export default SnackBarNotification;